<template>
  <NuxtLayout
    name="radar"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main">
        <SectionTitle
          title="世界の雨雲レーダー"
          :left-text="`日本時刻 ${now.locale(ja).format('M/D(ddd) H時')}`"
          share-category="RADAR_TOP"
          :share-title="title"
          is-h1
        />
        <MapRadar
          :now="now"
          :lat="35"
          :lon="135"
          :zoom="0.5"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <text-link
          text="世界の天気を見る"
          href="/"
        />
        <CommonCountryList is-radar />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'

dayjs.extend(utc)
dayjs.extend(timezone)

const now = dayjs().startOf('hour').tz('Asia/Tokyo')

const runtimeConfig = useRuntimeConfig()
const domain = runtimeConfig.public.hostDomain

const breadcrumb = [
  {
    text: '世界天気',
    link: `${domain}/onebox/tenki/world/`
  },
  {
    text: '雨雲レーダー 世界'
  }
]
const title = '世界の雨雲レーダー【予想48時間】 - ウェザーニュース'
useCommonHead({
  title,
  description: '世界の雨雲レーダーは、リアルタイムな雨雲の動きから最大48時間先の予報まで確認できます。旅の出発前には2週間天気や空港の天気も併せてチェック。天気・気象に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。',
  keywords: '世界,雨雲レーダー,48時間',
  appTitle: '世界天気',
  appCountKey: 'radar',
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar@2x.png`
})
useCommonJsonld({ breadcrumb })
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
</style>
